import { render, staticRenderFns } from "./rcs.vue?vue&type=template&id=d28c2100"
import script from "./rcs.vue?vue&type=script&lang=js"
export * from "./rcs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports